import {atom} from "jotai";

export const detailsStateAtom = atom(false);
export const detailsDataAtom = atom({});